import React from 'react';
import {ExpressCheckoutButtons} from '@wix/ecom-platform-express-checkout-buttons/widget';
import {useControllerProps} from '../../domain/controllers/ControllerContext';

export const ExpressButtons = ({dataHook, withLoader}: {dataHook: string; withLoader?: boolean}) => {
  const {dynamicPaymentOptionsProps} = useControllerProps().cashierExpressStore;
  const {cartSummary, cartModel} = useControllerProps().cartStore;

  const shouldRequestShipping = dynamicPaymentOptionsProps?.shouldRequestShipping;

  return (
    <ExpressCheckoutButtons
      layout={'vertical'}
      withLoader={withLoader}
      currency={cartModel.paymentInfo.currencyCode}
      isShippable={shouldRequestShipping}
      estimatedTotal={cartSummary?.estimatedAmountToPay.toString()}
      canStartPayment={true}
      theme={dynamicPaymentOptionsProps?.getButtonTheme}
      buttonStyle={dynamicPaymentOptionsProps?.buttonStyle}
      dataHook={dataHook}
    />
  );
};
